<style scoped>
  .show_data_search{
    position:absolute;
    top:2px;
    right:3px;
    padding:5px;
    background-color:#cccccc;
    color:#55b2cd;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
  .layout {
    /*border: 1px solid #d7dde4;*/
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    height: 100%;
  }

  .layout-copy {
    text-align: center;
    padding-top:18px;
    /*color: #9ea7b4;*/
  }

  .layout-menu-left {
    background: rgb(113,150,159);
    position: fixed;
    width: 200px;
    height: 100%;
    z-index:1;
    /*overflow-y: hidden;*/
    border-right: 1px solid lightgray;
    left: 0;
    top:-3px;
    background-image:url(../assets/u507.jpg);
    background-size: cover;
  }
  .ivu-breadcrumb{
    display: inline-block;
  }
  .layout-content-right {
    margin-left: 200px;
    position: relative;
    top:-6px;
    overflow-y: hidden;
  }

  .layout-header {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
    height:65px;
    line-height: 55px;
  }
.ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    background: none;
}
  .ivu-menu{
    /*background: rgb(113,150,159);*/
    color:white;
    background:rgba(0,2,10,0.2);
    /*opacity: 0.3;*/

  }
  .layout-logo-left {
    width: 100%;
    height: 80px;
    /*background: rgba(0,0,0,0);*/
    text-align: center;
    /*border-radius: 3px;*/
    /*margin: 15px auto;*/
    /*color: #fff;*/
    padding: 10px;
    border-bottom: 1px solid #fff;

  }

  .layout-logo-left img{

    /*height:100%;*/
    margin-right: 100px;
    /*font-size: 20px;*/
    /*font-weight: 700;*/
  }

  .user-banner {
    float: right;
    vertical-align: middle;
    padding: 6px 15px;
  }

  .user-banner-icon {
    vertical-align: middle
  }

  .user-banner-message {
    margin-right: 20px
  }
  .leftnavk{
    display: block;
    /*height: 48px;*/
    margin-top: -50px;
    margin-left: 70px;
  }
  .leftnavk p{
    width:110px;
    /*float: right; */
    /*word-break: break-all; word-wrap:break-word;*/
    text-align: left;
    font-size: 12px;
    text-decoration: underline;
    /*display: inline-block;*/
        margin:0px 1px 0 0;
    /*padding: 0;*/

  }
  .ivu-menu-vertical.ivu-menu-light:after {
    /*background: none;*/
  }

  .layout-mobile-content {
    margin-left: 0px;
  }

  .layout-mobile-menu {
    display: none;
  }

  a {
    text-decoration: none;
  }
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu){
    /*color:#0F0F0F;*/
    /*border: none;*/
  }
  .ipt{
    line-height: 180%;
    width: 258px;
    /*margin*/
  }
  .cance{
    position: absolute;
    left: 80px;
    font-size:12px;
    top: 63px;
    cursor: pointer;
  }
  .changePwd{
    position: absolute;
    left: 80px;
    font-size:12px;
    top: 34px;
    color: white;
    border:none;
    cursor: pointer;

    /*background-color: rgb(255,255,1);*/
    /*opacity: 0.3;*/
  }
  .getmessage{
    position: absolute;
    left: 80px;
    font-size:12px;
    top:49px;
    color: white;
    border:none;
    cursor: pointer;
  }
  .youxiang{
    background-color: red !important;
  }
  .guanguan{
    float: right;
  }
/*  .campany{
    margin-top: -6px;
  }*/
/*  .zhezhao{
    width: 100%;
    height: 1100px;
     background-color: rgba(0,0,0.5);
    opacity: 0.1;
  }*/
</style>

<template>
  <div class="layout" :class="{'layout-hide-text': spanLeft < 5}">
    <div>

      <div class="layout-menu-left" :class="{'layout-mobile-menu' : isLeftHiden}">

        <Menu active-name="1-2" width="auto" :open-names="['1']">

          <div class="layout-logo-left container-fluid">
            <div class="contenttxt row">
               <img src="../assets/u510.png" alt="" />

                <span class="leftnavk col-md-4">

                  <p href="">{{loginname}}</p>
                  <p class="campany" style="margin-top:-3px;">{{company}}</p>
                </span>
                  <div class="cance" @click='zhuxiao(1)'>[{{language.zhuxiao}}]</div>
                   <p @click="modal = true" type="text" class="changePwd">[{{language.xiugaimima}}]</p>
                   <p @click="xiugaiyouxiang" type="text" class="getmessage">[{{language.xiugaiyouxiang}}]</p>

                   <Modal v-model="modal" >
                        <change-pwd :userName = 'username'> </change-pwd>

                    <div slot="footer" style="display:none;">

                    </div>
                   </Modal>
                   

                   <Modal v-model="modals":mask-closable="false" :closable="false" class-name="youxiang" style="background-color:black">
                    <span v-show="guanbi" @click="guanguan" class="guanguan"><Icon type="close-circled"></Icon></span>
                        <p><span>修改邮箱</span></p>
                        <p><Input placeholder="输入您的邮箱" v-model="emailnum" clearable style="width: 200px margin:0  auto"></Input></p>

                         <div slot="footer">
                            <Button type="success" size="large" long  @click="querenshijian()">确认</Button>
                        </div> 
                    
                   </Modal>
                    
                  
            </div>


          </div>

          <!-- 根据数组显示左侧导航 start -->
          <div v-for="(item,index) in menuLists">

            <div v-if="!item.childMenu">
              <Menu-item  @click.native="goto('/'+item.url)"  :name="index+'-'+index">
                <Icon :type="item.icon">
                </Icon>
                {{item.name}}
              </Menu-item >
            </div>
            <div v-else>
              <Submenu :name="index">

                <template slot="title" >
                  <Icon :type="item.icon"></Icon>
                  {{item.name}}
                </template>
                 <Menu-item @click.native="goto('/'+list.url)" style="color:#0F0F0F;" v-for="(list,index1) in item.lists" :name="index+'-'+index1" >{{list.name}} </Menu-item>
                </Submenu>
            </div>

          </div>

          <!-- 根据数组显示左侧导航 end -->
        <!-- <button @click="ppp()">{{language.customer}}</button> -->
        </Menu>
      </div>
      <div class="layout-content-right "  :class="{'layout-mobile-content' : isLeftHiden}">

        <!-- <div class="layout-header"> -->


         <!--  <i-button type="text" @click="toggleClick" style="    margin-top: 10px;">
            <Icon type="navicon" size="30"></Icon>
          </i-button> -->
             <!-- <Breadcrumb> -->
<!--       <Breadcrumb>
        <BreadcrumbItem to="/">Home</BreadcrumbItem>
        <BreadcrumbItem to="/delivery">Components</BreadcrumbItem>
        <BreadcrumbItem>Breadcrumb</BreadcrumbItem>
    </Breadcrumb>

        </BreadcrumbItem> <-->

         <!-- </Breadcrumb> -->
<!--          <Breadcrumb>

         </Breadcrumb> -->
<!--           <div class="user-banner">

            <Badge class="user-banner-message">
              <input type="text" placeholder ="点击我查看" class="ipt" @click.self="dowsel()">
              <label v-show="searchNumber==''?false:true" class="show_data_search">共{{searchNumber}}条</label>
            </Badge>
          </div> -->
        <!-- </div> -->


        <transition name="fade">
          <search-form v-show="showForm" transiton="fade"></search-form>
        </transition>
        <div @click.stop="dowsell()">
          <!-- <keep-alive> -->
            <router-view></router-view>
          <!-- </keep-alive>  -->
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  import ChangePwd from '../components/ChangePwd'

  import {mapGetters,mapActions} from 'vuex'
  import searchForm from './searh'
  import axios from 'axios';
  import config from 'config/apiConfig';
  import language from 'api/language.js';
  export default {
    name:'index',
    data () {
      return {
        emaildata:0,
        guanbi:false,
        emailnum:"",
        modal:false,
        modals:false,
        language:{},
        showForm:false,
        // showFormInput:false,
        spanLeft: 5,
        spanRight: 19,
        isLeftHiden: false,
        company:"",
        loginname:"",
        username: '',
         items2: [{
            text: 'Admin',
            href: '#'
          }, {
            text: 'Manage',
            href: '#'
          }, {
            text: 'Library',
            active: true
          }],
        menuLists:[
       {
            name: language.shouye,
            icon:'ios-home',
            url:'firstpage',
            childMenu:false
          },
           {
            name: language.jiagongdingdanshenqing,
            icon:'gear-b',
            url:'addDingdan',
            // childMenu:false
          },
           {
            name: language.jiagongdingdanshenqingchakan,
            icon:'clipboard',
            url:'addpost',
            // childMenu:false
          },
          {
            name: language.tihuoshenqing,
            icon:'android-cart',
            url:'delivery',
            childMenu:false
          },
          {
            name: language.tihuoshenqingchakan,
            icon:'camera',
            url:'ladingsee',
            childMenu:false
          },
          {
            name: language.tihuojihua,
            icon:'calendar',
            url:'Original',
            childMenu:false
          },
           {
            name: language.xiaoshoutidanchakan,
            icon:'compose',
            url:'lading',
            childMenu:false
          },

          {
            name: language.zaikukucunchaxun,
            icon:'arrow-graph-up-right',
            url:'addmeau',
            childMenu:false
          },
          {
            name: language.yichukuchaxun,
            icon:'arrow-graph-up-left',
            url:'addmeauTwo',
            childMenu:false
          },

          {
            name: language.zhibaoshuchaxun,
            icon:'ios-book',
            url:'warranty',
            childMenu:false
          },
          {
            name: language.zhiliangshujufenxi,
            icon:'stats-bars',
            url:'qualitative',
            childMenu:false
          },

           ]

          }
        },

    // components: {searchForm},

    beforeMount () {
      const {body} = document
      const WIDTH = 768;
      const RATIO = 3;
      const handler = () => {
        if (!document.hidden) {
          let rect = body.getBoundingClientRect()
          let isMobile = rect.width - RATIO < WIDTH
          this.togglemobileauto(isMobile)
        }
      }
      document.addEventListener('visibilitychange', handler)
      window.addEventListener('DOMContentLoaded', handler)
      window.addEventListener('resize', handler);
    },
    components:{
      searchForm,
      ChangePwd
    },
    computed: {
      ...mapGetters({
        searchNumber: 'searchNumber',
      }),
      iconSize () {
        return this.spanLeft === 5 ? 14 : 24;
      } 
    },
    methods: {
        xiugaiyouxiang(){
            let that=this
            that.modals=true
            let user=localStorage.getItem("user")
            user=JSON.parse(localStorage.getItem("user"))
            // that.meishenmemingzinengqule()
            // let pops=storage.getItem("ifemail")
            if(user.email){
                that.guanbi=true
            }
        },
        guanguan(){
            this.modals=false
        },
        // meishenmemingzinengqule(){
        //     let that=this
        //     // debugger;
        //     let user=localStorage.getItem("user")
        //      user = JSON.parse(localStorage.getItem("user"));

        //     user.email=that.emailnum
        //     localStorage.setItem("user",JSON.stringify(user))

        //     // let that=this
        //     // debugger;
        //     // let user=localStorage.getItem("user")
        //     //  user = JSON.parse(localStorage.getItem("user"));

        //     // user.email=that.emailnum
        //     // localStorage.setItem("user",JSON.stringify(user.email))



        //     // user.email="dddddd";
        //     // localUser = that.emailnum;
        //     // localStorage.removeItem("user");
        //     // localStorage.setItem("user",user);

        // let token=sessionStorage.getItem("token");
                       
        // // let that = this
        //   axios.get(config.platForm+'/'+token,{}).then(function(response){
        //     // var c=localStorage.getItem("user");
        //     // c.email=that.emailnum
        //     // localStorage.setItem("user",JSON.stringify(c))
        //     if(response.data.resultData.BGM_SESSION.email&&response.data.resultData.BGM_SESSION.email!=""){
        //         that.guanbi=true
        //     }else if(!response.data.resultData.BGM_SESSION.email||response.data.resultData.BGM_SESSION.email==""){
        //          // that.modals=true
        //     that.guanbi=false
        //     }
        //   // that.company=response.data.resultData.BGM_SESSION.companyName
        //   // that.loginname=response.data.resultData.BGM_SESSION.memberLoginNo
        //   // if(!response.data.resultData.BGM_SESSION.email||response.data.resultData.BGM_SESSION.email==""){
        //   //   that.modals=true
        //   //   that.guanbi=false
        //   // }else if(response.data.resultData.BGM_SESSION.email&&response.data.resultData.BGM_SESSION.email!=""){
        //   //   that.emaildata=response.data.resultData.BGM_SESSION.email
        //   //   that.guanbi=true
        //   // }
        //   // if(!window.localStorage){
        //   //   return false
        //   // }else{
        //   // }

        //   })
        // },
    querenshijian(){
        let that= this
        // that.ppp()
        if(that.emailnum==null||that.emailnum==""){
            that.modals=true
            that.$Message.info(language.qingshuruyouxiang)
        }else{
            let reg=new RegExp("^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$"); 
            // that.emailnum=""
            if(!reg.test(that.emailnum)) {
                alert(language.qingjianchayouxianggeshi);
                }else{
                    let token=sessionStorage.getItem("token");
                    let params={
                        "email":that.emailnum
                    }
                    let headers={token:token}
                    axios.post(config.updateEmail ,params,{headers}).then(function(response){
                        if(response.status==200){
                            that.email=response.status
                            that.modals=false
                            that.emaildata=1
                            let user=localStorage.getItem("user")
                                 user = JSON.parse(localStorage.getItem("user"));

                                user.email=that.emailnum
                                localStorage.setItem("user",JSON.stringify(user))
                            // that.meishenmemingzinengqule();
                            that.$Message.info(language.caozuochenggong)
                        }
                    })
                }
                // axios.post('http://www.bgmsteelkscm.co.kr:8094/web/sys/user/updateEmail' ,{params},{headers}).then(function(response){
                //         if(response.status==200){
                //             that.modals=false
                //             that.$Message.info(response.data.msg)
                //         }
                //     })
                // }
            // that.modals=false
        }

    },
      zhuxiao(index){
        if(index==1){
          this.$router.push({ path: '/login' })
          window.localStorage.clear();
          window.sessionStorage.clear();
          axios.post(config.ccc).then(function(response){
          })
        }
      },
      toggleClick () {
        this.isLeftHiden = !this.isLeftHiden;
      },
      togglemobileauto(ismobile){
        this.isLeftHiden = ismobile
      },
      logout(){
        sessionStorage.removeItem('smartkitusername');
        sessionStorage.removeItem('islogin');
        this.$router.replace('Login')
      },
      goto(next){
        this.$router.push(next)
      },
      dowsel(){
        this.showForm = !this.showForm
      },
      dowsell(){
        this.showForm = false
      },
      ppp(){
        this.language = language;
          // let languages=[]
          let token=sessionStorage.getItem("token");
          let that = this
          let user=localStorage.getItem("user")
                                 user = JSON.parse(localStorage.getItem("user"));

                                user.email=that.emailnum
                                localStorage.setItem("user",JSON.stringify(user))
          axios.get(config.platForm+'/'+token,{}).then(function(response){
          that.company=response.data.resultData.BGM_SESSION.companyName
          that.loginname=response.data.resultData.BGM_SESSION.memberLoginNo
          if(!response.data.resultData.BGM_SESSION.email||response.data.resultData.BGM_SESSION.email==""){
            that.modals=true
            that.guanbi=false
          }else if(response.data.resultData.BGM_SESSION.email&&response.data.resultData.BGM_SESSION.email!=""){
            that.emaildata=response.data.resultData.BGM_SESSION.email
            that.guanbi=true
          }
          // if(!window.localStorage){
          //   return false
          // }else{
          //   localStorage.setItem("languages",JSON.stringify(response.data.resultData.BGM_SESSION.locale))
          // }

          })
      // )
      },
    },
    mounted(){
      this.ppp()
      this.username = sessionStorage.getItem('username')
    }
  }
</script>
<!-- <link rel="stylesheet" type="text/css" href="http://unpkg.com/iview/dist/styles/iview.css"> -->



// WEBPACK FOOTER //
// index.vue?4626072c